import { FC } from 'react'
import { CircleAlert, Dot, Minus } from 'lucide-react'
import { TooltipWrapper } from '@wellesley/ui'
import {
  EventDateNodes,
  ParseEventDatesProps,
  useParseEventDates,
} from '../../helpers/dates/Event.dates'

const DateNode: FC<EventDateNodes> = ({
  startDateStr,
  startTimeStr,
  endDateStr,
  endTimeStr,
  gmtStr,
}) => (
  <span className="[&_svg]:inline [&_svg]:align-sub">
    {gmtStr && <>Time at location&nbsp;</>}
    <>
      {startDateStr}
      <Dot size={16} />
      {startTimeStr}
    </>
    {endTimeStr && (
      <>
        <Minus size={16} className="mx-xxxs" />
        {endDateStr}
        {endDateStr && <Dot size={16} />}
        {endTimeStr}
      </>
    )}
    {gmtStr && <>&nbsp;({gmtStr})</>}
  </span>
)

export const DateTimeDisplay: FC<
  ParseEventDatesProps & { className?: string }
> = ({ className, ...dateProps }) => {
  const [local, source] = useParseEventDates(dateProps)

  return (
    <span className={className}>
      <DateNode {...local} />
      {source && (
        <TooltipWrapper
          theme="dark"
          size="small"
          tooltipText={<DateNode {...source} />}
          triggerClassname="inline ml-xxxs align-sub"
          side="bottom"
        >
          <CircleAlert size={16} />
        </TooltipWrapper>
      )}
    </span>
  )
}

DateTimeDisplay.displayName = 'DateTimeDisplay'
